"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpensePaymentFlowInformationEnum = void 0;
var ExpensePaymentFlowInformationEnum;
(function (ExpensePaymentFlowInformationEnum) {
    ExpensePaymentFlowInformationEnum["ALREADY_APPROVED_AND_PAID"] = "already_approved_and_paid";
    ExpensePaymentFlowInformationEnum["ALREADY_PAID"] = "already_paid";
    ExpensePaymentFlowInformationEnum["REPORTING_ONLY"] = "reporting_only";
})(ExpensePaymentFlowInformationEnum || (exports.ExpensePaymentFlowInformationEnum = ExpensePaymentFlowInformationEnum = {}));
